import AvenirNextBoldEOT from "../assets/fonts/AvriNextFont/avenir-next-bold.eot";
import AvenirNextBoldTTF from "../assets/fonts/AvriNextFont/avenir-next-bold.ttf";
import AvenirNextBoldWOFF from "../assets/fonts/AvriNextFont/avenir-next-bold.woff";
import AvenirNextRegularEOT from "../assets/fonts/AvriNextFont/avenir-next-regular.eot";
import AvenirNextRegularTTF from "../assets/fonts/AvriNextFont/avenir-next-regular.ttf";
import AvenirNextRegularWOFF from "../assets/fonts/AvriNextFont/avenir-next-regular.woff";
import AvenirNextThinEOT from "../assets/fonts/AvriNextFont/avenir-next-thin.eot";
import AvenirNextThinTTF from "../assets/fonts/AvriNextFont/avenir-next-thin.ttf";
import AvenirNextThinWOFF from "../assets/fonts/AvriNextFont/avenir-next-thin.woff";
import AvenirNextMediumEOT from "../assets/fonts/AvriNextFont/AvenirLTPro-Medium.eot";
import AvenirNextMediumTTF from "../assets/fonts/AvriNextFont/AvenirLTPro-Medium.ttf";
import AvenirNextMediumWOFF from "../assets/fonts/AvriNextFont/AvenirLTPro-Medium.woff";
import FullLogo from "../assets/images/group-3@3x.png";

export function consultNoteGenerateHTMLCode(patientName, gender, dob, uin, consultDate, notesDataJson, attachmentDesign, doctorName) {
  let consultNotePDF = "";
  consultNotePDF += "";
  consultNotePDF += "<!DOCTYPE html>";
  consultNotePDF += '<html lang="en">';
  consultNotePDF += "<head>";
  consultNotePDF += "        <title>Consult Note</title>";
  consultNotePDF += '            <meta charset="utf-8">';
  consultNotePDF +=
    '            <meta name="viewport" content="width=device-width, initial-scale=1">';
  consultNotePDF +=
    '            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">';
  consultNotePDF +=
    '            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">';
  consultNotePDF +=
    '            <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.0/jquery.min.js"></script>';
  consultNotePDF +=
    '            <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script>';
  consultNotePDF += "            <style> body{padding:0px; margin:0px}";
  consultNotePDF += "                @font-face {";
  consultNotePDF += "        ";
  consultNotePDF += "                    font-family: 'AvenirNextBold';";
  consultNotePDF +=
    "                    src: url('" + AvenirNextBoldEOT + "');";
  consultNotePDF +=
    "                    src: url('" +
    AvenirNextBoldEOT +
    "') format('embedded-opentype'),";
  consultNotePDF +=
    "                    url('" + AvenirNextBoldWOFF + "') format('woff'),";
  consultNotePDF +=
    "                    url('" + AvenirNextBoldTTF + "') format('truetype');";
  consultNotePDF += "                }";
  consultNotePDF += "                @font-face {";
  consultNotePDF += "                    font-family: 'AvenirNextRegular';";
  consultNotePDF +=
    "                    src: url('" + AvenirNextRegularEOT + "');";
  consultNotePDF +=
    "                    src: url('" +
    AvenirNextRegularEOT +
    "') format('embedded-opentype'),";
  consultNotePDF +=
    "                    url('" + AvenirNextRegularWOFF + "') format('woff'),";
  consultNotePDF +=
    "                    url('" +
    AvenirNextRegularTTF +
    "') format('truetype');";
  consultNotePDF += "                }";
  consultNotePDF += "                @font-face {";
  consultNotePDF += "                    font-family: 'AvenirNextThin';";
  consultNotePDF +=
    "                    src: url('" + AvenirNextThinEOT + "');";
  consultNotePDF +=
    "                    src: url('" +
    AvenirNextThinEOT +
    "') format('embedded-opentype'),";
  consultNotePDF +=
    "                    url('" + AvenirNextThinWOFF + "') format('woff'),";
  consultNotePDF +=
    "                    url('" + AvenirNextThinTTF + "') format('truetype');";
  consultNotePDF += "                }";
  consultNotePDF += "                @font-face {";
  consultNotePDF += "                    font-family: 'AvenirNextMedium';";
  consultNotePDF +=
    "                    src: url('" + AvenirNextMediumEOT + "');";
  consultNotePDF +=
    "                    src: url('" +
    AvenirNextMediumEOT +
    "?#iefix') format('embedded-opentype'),";
  consultNotePDF +=
    "                    url('" + AvenirNextMediumWOFF + "') format('woff'),";
  consultNotePDF +=
    "                    url('" +
    AvenirNextMediumTTF +
    "') format('truetype');";
  consultNotePDF += "                    font-weight: 500;";
  consultNotePDF += "                    font-style: normal;";
  consultNotePDF += "                }";
  consultNotePDF += "                .class1 {";
  consultNotePDF += "                    max-width: 100%;";
  consultNotePDF += "                    width: 100%;";
  consultNotePDF += "                    margin: 0 auto;";
  consultNotePDF += "                    margin-top: 1%;";
  consultNotePDF += "                    padding: 15px 30px;";
  consultNotePDF += "                }";

  consultNotePDF +=
    ".custom-tbl, .custom-tbl thead tr td, .custom-tbl tbody tr td, .custom-tbl tbody tr { border: 0}";

  consultNotePDF += `
      .insta-label {
        font-family: AvenirNextRegular;
        font-size: 15px;
        margin-left: 0;
        color: #262626;
    }
    .insta-label.gray {
        color: #7f7f7f;
        font-family: AvenirNextRegular;
    }
    .user-img-container {
        height: 56px;
        width: 56px;
        margin-top: 5px;
        margin-right: 15px;
        object-fit: cover;
    }
    .patient-name-lbl {
        font-family: AvenirNextRegular;
        font-size: 25px;
        font-weight: 600;
        text-transform: capitalize;
        color: black;
    }

    .consult-note-dropdown-group {
        min-width: 235px;
    }

    .insta-link-default {
        font-family: AvenirNextRegular;
        font-size: 18px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        color: #999999;
    }

    .consult-note-pdf-btn {
        padding: 13px 10px;
        background-color: #dd2c00;
        color: white !important;
        font-size: 12px;
    }

    .font-12 {
        font-size: 12px !important;
    }

    .consult-note-btn {
        min-width: 130px !important;
        font-weight: normal;
    }

    .insta-button-primary.small {
        font-size: 13px;
        padding: 0;
        min-width: auto;
        padding: 0 20px;
        height: 40px;
    }

    .insta-button-primary.gray {
        min-width: 130px;
        border-radius: 4px;
        background-color: rgba(230, 230, 230, 0.55);
        border: 1px solid rgba(230, 230, 230, 0.55);
        color: #7f7f7f;
        transition: 0.3s;
        font-size: 13px;
        font-style: normal;
        font-stretch: normal;
        font-family: AvenirNextMedium;
    }

    .btn-group > .btn:not(:first-child), .btn-group > .btn-group:not(:first-child) {
        margin-left: -1px;
    }

    .btn-group, .btn-group-vertical {
        position: relative;
        display: inline-flex;
        vertical-align: middle;
    }

    .btn-group > .btn:not(:first-child), .btn-group > .btn-group:not(:first-child) > .btn {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .btn-group > .btn:not(:last-child):not(.dropdown-toggle), .btn-group > .btn-group:not(:last-child) > .btn {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .consult-note-container .consult-note-dropdown-group .dropdown-toggle-icon {
        background-color: #dae0e5 !important;
        border-color: #dae0e5 !important;
        color: #7f7f7f;
    }

    .lighter-text.xs-small {
        opacity: 0.6;
        font-family: AvenirNextRegular;
        font-size: 13px;
        color: #262626;
    }

      `;

  consultNotePDF += "            </style>";
  consultNotePDF += "        </head>";
  consultNotePDF += '        <body style="background-color: #f5f8f9;">';
  consultNotePDF += '        <div class="container class1">';

  consultNotePDF += `
        <div class="row m-0 pl-3" >
            <div class="col-sm-2 col-md-2 w-25 " style="text-align:left;padding:0px;overflow:hidden;">
                <img src='${FullLogo}' style="width:180px;height:auto;padding-bottom: 3px"  alt="logo"/>
            </div>
            <div class="col-sm-2 col-md-2 pt-4 pr-4" style="text-align:right;padding:0px;">
                <div style="font-family:AvenirNextMedium; font-size:20px; color: black;font-weight: bold">
                    Consult Note
                </div>
            </div>
        </div>
  `;

  consultNotePDF += `   
  <div class="row patient-record-header m-0 mt-4">
    <div class="col-sm-4">
        <label class="insta-label m-0 big patient-name-lbl">${patientName}</label> <br>
        <label class="insta-label gray">${gender}</label>
        <label class="insta-label gray ml-3">${dob}</label>
        <label class="insta-label gray ml-3">UIN: ${uin}</label>
    </div>
</div>

    <div class="row mt-4 m-0">
        <div class="col-sm-4">
            <label class="insta-label font-weight-bold">${consultDate}</label>
        </div>
        <div class="w-100"></div>
        <div class="col-sm-4 ml-3 border-bottom"></div>
        ${notesDataJson}
    </div>

    <div class="row m-0 mt-4 pl-3" style="max-width:730px">
        ${attachmentDesign}
        
    </div>

    <div class="row m-0 mt-3">
        <div class="col-sm-3"> 
            <p class="lighter-text xs-small pt-2 w-100">${doctorName}</p>
        </div>
    </div>


`;

  consultNotePDF += "        </div>";
  consultNotePDF += "        </body>";
  consultNotePDF += "        </html>";

  return consultNotePDF;
}


{/* <div class="w-100"></div>
        <div class="col-sm-4 d-flex flex-row">
            <p class="insta-label small light mb-0">Patient understands and consents to the nature and limitations of a telemedicine consultation</p>
        </div>
        <div class="w-100"></div>
        <div class="col-sm-4 d-flex flex-row">
            <p class="insta-label small light mb-0">Presenting Complaint: test</p>
        </div>
        <div class="w-100"></div>
        <div class="col-sm-4 d-flex flex-row">
            <p class="insta-label small light mb-0">Impression: test</p>
        </div>
        <div class="w-100"></div>
        <div class="col-sm-4 d-flex flex-row">
            <p class="insta-label mb-0 small light mb-0">Plan: test</p>
        </div>
        <div class="w-100"></div> */}

        // <div class="col-sm-3 p-1 consult-note-dropdown-group">
        //     <div class="btn-group">
        //         <a href="#" class="link insta-link-default consult-note-pdf-btn font-12" target="_blank"> PDF </a>
        //         <a href="#" target="_blank">
        //             <button type="button" class="insta-button-primary gray small border-radius-0 pl-2 pr-2 m-0 text-left consult-note-btn font-12 btn btn-primary">Prescription.pdf</button>
        //         </a>
        //         <div class="btn-group">
        //             <button type="button" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle-icon btn" style="border-top-right-radius: 0px;border-bottom-right-radius: 0px;background-color: #dae0e5; border-color: #dae0e5; padding-top: 0px">
        //                 <img src=${menuSVG} alt="menubar" style="width:15px" />
        //             </button>
        //         </div>
        //     </div>
